<div>
    <div class="tab-content-loader-container" *ngIf="getTPConfigInProcess">
        <loader height="100" width="100" style="opacity: 0.8;"></loader>
    </div>
    <div class="flex-column gap-4" *ngIf="!getTPConfigInProcess && planUsers && planUsers?.length">
        <div class="list-group list-group-flush settings-list-container">
            <!--Choose user for lists banner-->
            <div class="list-group-item mw-100 settings-list-item pt-0 pb-2 border-0 border-bottom rounded-0 shadow-none animated fadeIn" style="z-index: 20; background: linear-gradient(0deg, #f7f7f7, #f7f7f700) !important; height: 50px;">
                <div class="flex-row w-100 gap-5 align-items-center" style="max-width: 1200px;">
                    <div class="flxRow hSpace2" style="align-items: center;">
                        <div>View lists for:</div>
                        <app-dropdown-c style="width: 260px; height: 32px;"
                                      [enableSearch]="true"
                                      [items]="planUsers"
                                      itemDisplayKey="email"
                                      (onItemClicked)="changeUser($event.item)"
                                      text="{{currentUser}}"></app-dropdown-c>
                    </div>
                    <div class="flex-column gap-2">
                        <a class="flex-row gap-1 align-items-center position-relative"
                           [ngClass]="{'disabled' : exportAllListsToCsvInProcess}"
                           (click)="exportAllListsToCsv()">
                            <i class="far fa-file-export fa-sm"></i>
                            <span style="white-space: nowrap;">Generate user lists report</span>
                            <div class="loading-spinner" style="left: -20px; transform: translate(50%, -100%); top: 1px; width: 11px; height: 11px; border-width: 1px;"
                                 tooltip="Generating report... Might take a while"
                                 *ngIf="exportAllListsToCsvInProcess"></div>
                        </a>
                        <a class="flex-row gap-1 align-items-center" (click)="showRecipientConfig()">
                            <i class="far fa-cog"></i>
                            <span style="white-space: nowrap;">Personal list settings</span>
                        </a>
                    </div>
                </div>
            </div>

            <!--Settings: Block/Allow Senders -->
            <div class="list-group-item mw-100 settings-list-item border-0 shadow-none column-style"
				 style="padding-top: 10px !important;"
				 *ngIf="gs.getTabName() === dic.CONSTANTS.inboundConfigurationPageTabs.senderLists">
                <div class="content-container flex-column gap-3">
                    <!--Senders Whitelist-->
                    <div class="flex-column gap-3">
                        <div class="flex-column gap-2">
                            <div class="flex-row align-items-center gap-1">
                                <i class="far fa-check-circle text-success" style="font-size: 0.7rem;"></i>
                                <b style="font-size: 0.845rem;">Senders Allowlist</b>
                            </div>
                            <span class="text-muted lh-base" style="font-size: 0.9em;">Emails from senders on this list will be treated as safe unless they conflict with your Allowlisted Sender Advanced Settings</span>
                        </div>
                        <div class="flxClmn vSpace1 animated fadeIn" style="background-color: white; height: max(330px,25vw);">
                            <trustifi-table-c
                                    class="trustifi-table" style="flex: 1 0; z-index: 5; height: 330px;"
                                    [list]="currentLists.senders_whitelist"
                                    [headers]="[
										{text: 'Sender', sortKey: 'email',  width: '33%'},
										{text: 'Match Type', width: '130px', sortKey: 'matchType', tooltip: 'For domains, IP, and CIDR only the Exact Match type is fully supported'},
										{text: 'Description', width: '37%' },
										{text: 'Updated by', width: '37%' },
										{text: 'Last Update', sortKey: 'created', width: '20%' },
										{text: 'Last Used', sortKey: 'last_used', width: '20%' },
									]"
                                    [cellsPrototype]="[
										{html: 'whitelistSenderEmailCell', edit: {modelKey: 'email', placeholder: 'Email/Domain/IP/CIDR'}},
										{textKey: 'matchType', overflowOutside: true, edit: {html: 'senderWhitelistMatchTypeCellEdit'}, style: {'text-transform' : 'capitalize'}},
										{textKey: 'description', tooltip: true, edit: {modelKey: 'description', placeholder: 'Description'}},
										{textKey: 'updated_by'},
										{textKey: 'created', textType: 'dateAndTime', style: {'word-break': 'break-word', 'white-space': 'normal'}},
										{textKey: 'last_used', textType: 'dateAndTime', style: {'word-break': 'break-word', 'white-space': 'normal'}},
									]"
                                    [bulkActions] = "{
										enable: true,
										selectBulkActionCb:	selectMultipleWhitelistAction,
										initBulkActionsFunction: showWhitelistBulkActions,
										showInRed: {enable: true, terms: ['Remove']}
									}"
                                    [cellActions] = "{
										enable: true,
										isSmaller: true,
										selectItemActionCb:	selectWhitelistAction,
										initActionsFunction: showWhitelistActions,
										showInRed: {enable: true, terms: ['Remove']}
									}"
                                    (searchFunction)="searchSendersWhitelist($event.searchTerm, $event.activeFilters)"
                                    (confirmEditFunction)="confirmEditSendersWhitelist($event.item, $event.isApproved)"
                                    [options]="{
										importFromCsv : {cbFunction : uploadSendersWhitelistFromFile, tooltip: 'A column named \'sender\' should contain the senders'},
										exportToCsvFunction: exportSendersWhitelistToCsv,
										itemsNameSingular: 'sender',
										itemUniqueIdentifier: 'email',
										defaultSortKey: '-created',
									}"
                            >
                                <!--sender email cells-->
								<ng-template #customCells let-item let-cellId="cellId">
									<div *ngIf="cellId === 'whitelistSenderEmailCell'">
										<i class="far fa-clipboard"
										   style="float: left;"
										   [ngStyle]="!item.skip_keep_record ? {'color': 'green','margin' : '0 3px'} : {'color': '#b1b1b1','margin' : '0 3px'}"
										   tooltip="Record of quarantined emails will{{item.skip_keep_record ? ' not' : ''}} be kept for this sender"
										>
										</i>
										<div style="width: fit-content; max-width: calc(100% - 20px); white-space: nowrap;" tooltip="{{item.email}}" placement="top" >{{item.email}}</div>
									</div>
									<span *ngIf="cellId === 'senderWhitelistMatchTypeCellEdit'">
										<app-dropdown-c class="w100 h100" text="{{item.edit.matchType}}">
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.exactMatch"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.exactMatch]>
												{{dic.CONSTANTS.ruleMatchType.exactMatch}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.startsWith"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.startsWith]>
												{{dic.CONSTANTS.ruleMatchType.startsWith}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.endsWith"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.endsWith]>
												{{dic.CONSTANTS.ruleMatchType.endsWith}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.contains"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.contains]>
												{{dic.CONSTANTS.ruleMatchType.contains}}
											</li>
										</app-dropdown-c>
									</span>
								</ng-template>
                                <!---->
                                <div tableButtons>
                                    <div class="w100 flex-row hSpace05 text-nowrap">
                                        <btn-c endIcon="far fa-plus"
                                             [isDisabled]="currentLists?.senders_whitelist?.isAddRecordActive"
                                             (action)="startAddRecord(currentLists?.senders_whitelist);">
                                            Add Allowlisted Sender
                                        </btn-c>
                                        <btn-c class="animated fadeIn"
                                             *ngIf="currentUser === dic.CONSTANTS.planDefaultUser"
                                             variant="outlined"
                                             (action)="showWhiteListConfig();">
                                            Advanced
                                        </btn-c>
                                    </div>
                                </div>
                            </trustifi-table-c>
                        </div>
                    </div>
                    <br/>
                    <!--Senders Blocklist-->
                    <div class="flex-column gap-3">
                        <div class="flex-column gap-2">
                            <div class="flex-row align-items-center gap-1">
                                <i class="far fa-times-circle text-danger" style="font-size: 0.7rem;"></i>
                                <b style="font-size: 0.845rem;">Senders Blocklist</b>
                            </div>
                            <span class="text-muted lh-base" style="font-size: 0.9em;">Emails from senders in this list will always be considered malicious</span>
                        </div>
                        <div class="flxClmn vSpace1 animated fadeIn" style="background-color: white; height: max(330px,25vw);">
                            <trustifi-table-c
                                    class="trustifi-table" style="flex: 1 0; z-index: 5; height: 330px;"
                                    [list]="currentLists.senders_blacklist"
                                    [headers]="[
										{text: 'Sender', sortKey: 'email',  width: '33%'},
										{text: 'Match Type', width: '130px', sortKey: 'matchType', tooltip: 'For domains, IP, and CIDR only the Exact Match type is fully supported'},
										{text: 'Description', width: '37%' },
										{text: 'Updated by', width: '37%' },
										{text: 'Last Update', sortKey: 'created', width: '20%' },
										{text: 'Last Used', sortKey: 'last_used', width: '20%' },
									]"
                                    [cellsPrototype]="[
										{html: 'blacklistSenderEmailCell', edit: {modelKey: 'email', placeholder: 'Email/Domain/IP/CIDR'}},
										{textKey: 'matchType', overflowOutside: true, edit: {html: 'senderBlacklistMatchTypeCellEdit'}, style: {'text-transform' : 'capitalize'}},
										{textKey: 'description', tooltip: true, edit: {modelKey: 'description', placeholder: 'Description'}},
										{textKey: 'updated_by'},
										{textKey: 'created', textType: 'dateAndTime', style: {'word-break': 'break-word', 'white-space': 'normal'}},
										{textKey: 'last_used', textType: 'dateAndTime', style: {'word-break': 'break-word', 'white-space': 'normal'}},
									]"
                                    [bulkActions] = "{
										enable: true,
										selectBulkActionCb:	selectMultipleBlacklistAction,
										initBulkActionsFunction: showBlacklistBulkActions,
										showInRed: {enable: true, terms: ['Remove']}
									}"
                                    [cellActions] = "{
										enable: true,
										isSmaller: true,
										selectItemActionCb:	selectBlacklistAction,
										initActionsFunction: showBlacklistActions,
										showInRed: {enable: true, terms: ['Remove']}
									}"
                                    (searchFunction)="searchSendersBlacklist($event.searchTerm, $event.activeFilters)"
                                    (confirmEditFunction)="confirmEditSendersBlacklist($event.item, $event.isApproved)"
                                    [options]="{
										importFromCsv : {cbFunction : uploadSendersBlacklistFromFile, tooltip: 'A column named \'sender\' should contain the senders'},
										exportToCsvFunction: exportSendersBlacklistToCsv,
										itemsNameSingular: 'sender',
										itemUniqueIdentifier: 'email',
										defaultSortKey: '-created',
									}"
                            >
                                <!--sender email cells-->
								<ng-template #customCells let-item let-cellId="cellId">
									<div *ngIf="cellId === 'blacklistSenderEmailCell'">
										<i class="far fa-clipboard"
										   style="float: left;"
										   [ngStyle]="!item.skip_keep_record ? {'color': 'green','margin' : '0 3px'} : {'color': '#b1b1b1','margin' : '0 3px'}"
										   tooltip="Record of quarantined emails will{{item.skip_keep_record ? ' not' : ''}} be kept for this sender"
										>
										</i>
										<div style="width: fit-content; max-width: calc(100% - 20px); white-space: nowrap;" tooltip="{{item.email}}" placement="top" >{{item.email}}</div>
									</div>
									<span *ngIf="cellId === 'senderBlacklistMatchTypeCellEdit'">
										<app-dropdown-c class="w100 h100" text="{{item.edit.matchType}}">
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.exactMatch"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.exactMatch]>
												{{dic.CONSTANTS.ruleMatchType.exactMatch}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.startsWith"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.startsWith]>
												{{dic.CONSTANTS.ruleMatchType.startsWith}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.endsWith"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.endsWith]>
												{{dic.CONSTANTS.ruleMatchType.endsWith}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.contains"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.contains]>
												{{dic.CONSTANTS.ruleMatchType.contains}}
											</li>
										</app-dropdown-c>
									</span>
								</ng-template>
                                <!---->
                                <div tableButtons>
                                    <div class="w100 flex-row hSpace05 text-nowrap">
                                        <btn-c endIcon="far fa-plus"
                                             [isDisabled]="currentLists?.senders_blacklist?.isAddRecordActive"
                                             (action)="startAddRecord(currentLists?.senders_blacklist);">
                                            Add Blocklisted Sender
                                        </btn-c>
                                        <btn-c class="animated fadeIn"
                                             *ngIf="currentUser === dic.CONSTANTS.planDefaultUser"
                                             variant="outlined"
                                             (action)="showBlackListConfig();">
                                            Advanced
                                        </btn-c>
                                    </div>
                                </div>
                            </trustifi-table-c>
                        </div>
                    </div>
                </div>
            </div>

            <!--Settings: Block/Allow Links -->
            <div class="list-group-item mw-100 settings-list-item border-0 shadow-none column-style"
				 style="padding-top: 10px !important;"
				 *ngIf="gs.getTabName() === dic.CONSTANTS.inboundConfigurationPageTabs.linkLists">
                <div class="content-container flex-column gap-3">
                    <!--Links Whitelist-->
                    <div class="flex-column gap-3">
                        <div class="flex-column gap-2">
                            <div class="flex-row align-items-center gap-1">
                                <i class="far fa-check-circle text-success" style="font-size: 0.7rem;"></i>
                                <b style="font-size: 0.845rem;">Links Allowlist</b>
                            </div>
                            <span class="text-muted lh-base" style="font-size: 0.9em;">Links from this list will always be considered safe</span>
                        </div>
                        <div class="flxClmn vSpace1 animated fadeIn" style="background-color: white; height: max(330px,25vw);">
                            <trustifi-table-c
                                    class="trustifi-table" style="flex: 1 0; z-index: 5; height: 330px;"
                                    [list]="currentLists?.links_whitelist"
                                    [headers]="[
										{text: 'Allowlisted URL', sortKey: 'link',  width: '33%'},
										{text: 'Match Type', width: '130px', sortKey: 'matchType'},
										{text: 'Description', width: '37%' },
										{text: 'Updated by', width: '20%' },
										{text: 'Last Update', sortKey: 'created', width: '20%' },
									]"
                                    [cellsPrototype]="[
										{textKey: 'link', edit: {modelKey: 'link', placeholder: 'Link URL'}},
										{textKey: 'matchType', overflowOutside: true, edit: {html: 'linksWhitelistMatchTypeCellEdit'}, style: {'text-transform' : 'capitalize'}},
										{textKey: 'description', tooltip: true, edit: {modelKey: 'description', placeholder: 'Description'}},
										{textKey: 'updated_by'},
										{textKey: 'created', textType: 'dateAndTime'},
									]"
                                    [bulkActions] = "{
										enable: true,
										selectBulkActionCb:	selectMultipleLinksWhitelistAction,
										initBulkActionsFunction: showLinksWhitelistBulkActions,
										showInRed: {enable: true, terms: ['Remove']}
									}"
                                    [cellActions] = "{
										enable: true,
										isSmaller: true,
										selectItemActionCb:	selectLinksWhitelistAction,
										initActionsFunction: showLinksWhitelistActions,
										showInRed: {enable: true, terms: ['Remove']}
									}"
                                    (searchFunction)="searchLinksWhitelist($event.searchTerm, $event.activeFilters)"
                                    (confirmEditFunction)="confirmEditLinksWhitelist($event.item, $event.isApproved)"
                                    [options]="{
										importFromCsv : {cbFunction : uploadLinksWhitelistFromFile, tooltip: 'A column named \'link\' should contain the links'},
										exportToCsvFunction: exportLinksWhitelistToCsv,
										itemsNameSingular: 'link',
										itemUniqueIdentifier: 'link',
										defaultSortKey: '-created',
									}"
                            >
                                <!--link match type EDIT-->
								<ng-template #customCells let-item let-cellId="cellId">
									<!--action cells-->
									<span *ngIf="cellId === 'linksWhitelistMatchTypeCellEdit'">
										<app-dropdown-c class="w100 h100" text="{{item.edit.matchType}}">
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.exactMatch"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.exactMatch]>
												{{dic.CONSTANTS.ruleMatchType.exactMatch}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.startsWith"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.startsWith]>
												{{dic.CONSTANTS.ruleMatchType.startsWith}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.endsWith"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.endsWith]>
												{{dic.CONSTANTS.ruleMatchType.endsWith}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.contains"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.contains]>
												{{dic.CONSTANTS.ruleMatchType.contains}}
											</li>
										</app-dropdown-c>
									</span>
								</ng-template>
                                <!---->
                                <div tableButtons>
                                    <div class="w100 flex-row text-nowrap">
                                        <btn-c endIcon="far fa-plus"
                                             [isDisabled]="currentLists?.links_whitelist?.isAddRecordActive"
                                             (action)="startAddRecord(currentLists?.links_whitelist);">
                                            Add Allowlisted Link
                                        </btn-c>
                                    </div>
                                </div>
                            </trustifi-table-c>
                        </div>
                    </div>
                    <br/>
                    <!--Links Blocklist-->
                    <div class="flex-column gap-3">
                        <div class="flex-column gap-2">
                            <div class="flex-row align-items-center gap-1">
                                <i class="far fa-times-circle text-danger" style="font-size: 0.7rem;"></i>
                                <b style="font-size: 0.845rem;">Links Blocklist</b>
                            </div>
                            <span class="text-muted lh-base" style="font-size: 0.9em;">Links from this list will always be considered malicious</span>
                        </div>
                        <div class="flxClmn vSpace1 animated fadeIn" style="background-color: white; height: max(330px,25vw);">
                            <trustifi-table-c
                                    class="trustifi-table" style="flex: 1 0; z-index: 5; height: 330px;"
                                    [list]="currentLists?.links_blacklist"
                                    [headers]="[
										{text: 'Blocklisted URL', sortKey: 'link',  width: '33%'},
										{text: 'Match Type', width: '130px', sortKey: 'matchType'},
										{text: 'Description', width: '37%' },
										{text: 'Updated by', width: '20%' },
										{text: 'Last Update', sortKey: 'created', width: '20%' },
									]"
                                    [cellsPrototype]="[
										{textKey: 'link', edit: {modelKey: 'link', placeholder: 'Link'}},
										{textKey: 'matchType', overflowOutside: true, edit: {html: 'linksBlacklistMatchTypeCellEdit'}, style: {'text-transform' : 'capitalize'}},
										{textKey: 'description', tooltip: true, edit: {modelKey: 'description', placeholder: 'Description'}},
										{textKey: 'updated_by'},
										{textKey: 'created', textType: 'dateAndTime'},
									]"
                                    [bulkActions] = "{
										enable: true,
										selectBulkActionCb:	selectMultipleLinksBlacklistAction,
										initBulkActionsFunction: showLinksBlacklistBulkActions,
										showInRed: {enable: true, terms: ['Remove']}
									}"
                                    [cellActions] = "{
										enable: true,
										isSmaller: true,
										selectItemActionCb:	selectLinksBlacklistAction,
										initActionsFunction: showLinksBlacklistActions,
										showInRed: {enable: true, terms: ['Remove']}
									}"
                                    (searchFunction)="searchLinksBlacklist($event.searchTerm, $event.activeFilters)"
                                    (confirmEditFunction)="confirmEditLinksBlacklist($event.item, $event.isApproved)"
                                    [options]="{
										importFromCsv : {cbFunction : uploadLinksBlacklistFromFile, tooltip: 'A column named \'link\' should contain the links'},
										exportToCsvFunction: exportLinksBlacklistToCsv,
										itemsNameSingular: 'link',
										itemUniqueIdentifier: 'link',
										defaultSortKey: '-created',
									}"
                            >
                                <!--link match type EDIT-->
								<ng-template #customCells let-item let-cellId="cellId">
									<!--action cells-->
									<span *ngIf="cellId === 'linksBlacklistMatchTypeCellEdit'">
										<app-dropdown-c class="w100 h100" text="{{item.edit.matchType}}">
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.exactMatch"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.exactMatch]>
												{{dic.CONSTANTS.ruleMatchType.exactMatch}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.startsWith"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.startsWith]>
												{{dic.CONSTANTS.ruleMatchType.startsWith}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.endsWith"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.endsWith]>
												{{dic.CONSTANTS.ruleMatchType.endsWith}}
											</li>
											<li (click)="item.edit.matchType = dic.CONSTANTS.ruleMatchType.contains"
												[explanationC]=dic.CONSTANTS.ruleMatchTypeTooltip[dic.CONSTANTS.ruleMatchType.contains]>
												{{dic.CONSTANTS.ruleMatchType.contains}}
											</li>
										</app-dropdown-c>
									</span>
								</ng-template>
                                <!---->
                                <div tableButtons>
                                    <div class="w100 flex-row text-nowrap">
                                        <btn-c endIcon="far fa-plus"
                                             [isDisabled]="currentLists?.links_blacklist?.isAddRecordActive"
                                             (action)="startAddRecord(currentLists?.links_blacklist);">
                                            Add Blocklisted Link
                                        </btn-c>
                                    </div>
                                </div>
                            </trustifi-table-c>
                        </div>
                    </div>
                </div>
            </div>

            <!--Settings: Block/Allow Attachments -->
            <div class="list-group-item mw-100 settings-list-item border-0 shadow-none column-style"
				 style="padding-top: 10px !important;"
				 *ngIf="gs.getTabName() === dic.CONSTANTS.inboundConfigurationPageTabs.attachmentLists">
                <div class="content-container flex-column gap-3">
                    <!--Attachments Whitelist-->
                    <div class="flex-column gap-3">
                        <div class="flex-column gap-2">
                            <div class="flex-row align-items-center gap-1">
                                <i class="far fa-check-circle text-success" style="font-size: 0.7rem;"></i>
                                <b style="font-size: 0.845rem;">Attachments Allowlist</b>
                            </div>
                            <span class="text-muted lh-base" style="font-size: 0.9em;">Files from this list will always be considered safe</span>
                        </div>
                        <trustifi-table-c
                                (ngInit)="whitelistFiles = null;"
								ngfDrop
                                multiple="1"
                                [(files)]="whitelistFiles"
                                (fileChange)="uploads(whitelistFiles, true)"
								[(validDrag)]="validDrag2"
								[(invalidDrag)]="invalidDrag2"
								[ngClass]="{'drag-and-drop-hover': validDrag2, 'dragOverClassObj': validDrag2}"
                                class="trustifi-table" style="z-index: 5; height: max(330px,25vw);"

                                [list]="currentLists?.attachments_whitelist"
                                [headers]="[
									{text: 'Allowlisted File', sortKey: 'name'},
									{text: 'Hash' },
									{text: 'Updated by' },
									{text: 'Created', sortKey: 'created', width: '135px'},
								]"
                                [cellsPrototype]="[
									{html: 'whitelistAttachmentNameCell', edit: {html: 'whitelistAttachmentNameCellEdit'}},
									{textKey: 'hash', tooltip: true},
									{textKey: 'updated_by'},
									{textKey: 'created', textType: 'dateAndTime'},
								]"
                                [bulkActions] = "{
									enable: true,
									selectBulkActionCb:	selectMultipleAttachmentsWhitelistAction,
									initBulkActionsFunction: showAttachmentsWhitelistBulkActions,
									showInRed: {enable: true, terms: ['Remove']}
								}"
                                [cellActions] = "{
									enable: true,
									isSmaller: true,
									selectItemActionCb:	selectAttachmentsWhitelistAction,
									initActionsFunction: showAttachmentsWhitelistActions,
									showInRed: {enable: true, terms: ['Remove']}
								}"
                                (searchFunction)="searchAttachmentsWhitelist($event.searchTerm, $event.activeFilters)"
                                (confirmEditFunction)="confirmNewWhitelistAttachment($event.item, $event.isApproved)"
                                [options]="{
									importFromCsv : {cbFunction : uploadAttachmentsWhitelistFromFile, tooltip: 'A column named \'hash\' should contain the hashes'},
									exportToCsvFunction: exportAttachmentsWhitelistToCsv,
									itemsNameSingular: 'attachment',
									defaultSortKey: '-created',
								}"
                        >
                            <!--attachment name cells-->
							<ng-template #customCells let-item let-cellId="cellId">
								<!--action cells-->
								<div *ngIf="cellId === 'whitelistAttachmentNameCell'">
									<div class="flxRow hSpace05 ellipsis">
										<span style="display: block;" tooltip="{{item.name}}">{{item.name}}</span>
										<span class="ellipsis" style="min-width: 80px;" *ngIf="item.size">({{item.size | FormatBytes:0}})</span>
									</div>
								</div>
								<!--whitelist attachment - EDIT MODE-->
								<div class="flxRow hSpace05 h100" style="overflow: visible;" *ngIf="cellId === 'whitelistAttachmentNameCellEdit'">
									<input type="text"
										   [(ngModel)]="item.edit['name']"
										   placeholder="Attachment Name"
										   style="margin-bottom: 0; height: 100%; flex: 1 0;"
										   (keydown.enter) = "confirmNewWhitelistAttachment($event.item, $event.true)">
									<input type="text"
										   [(ngModel)]="item.edit['hash']"
										   placeholder="SHA-256 or MD5"
										   style="margin-bottom: 0; margin-left: 5px; height: 100%; flex: 1 0;"
										   (keydown.enter) = "confirmNewWhitelistAttachment($event.item, $event.true)">
								</div>
							</ng-template>
                            <!---->
                            <div tableButtons>
                                <div class="flxRow hSpace2 text-nowrap" style="align-items: baseline;">
									<div class="btn-with-dropdown" style="width: 250px;">
										<btn-c (action)="startAddRecord(currentLists?.attachments_whitelist);"
											   endIcon="far fa-plus"
											   [isDisabled]="currentLists?.attachments_whitelist?.isAddRecordActive">
											Add Allowlisted Attachment
										</btn-c>
										<app-dropdown-c [isLf]="true">
											<li	ngfSelect
												   multiple="1"
												   [(files)]="whitelistFiles"
												   (fileChange)="uploads(whitelistFiles, true)">
												Add from my computer
											</li>
										</app-dropdown-c>
									</div>
                                    <span class="text-muted" style="font-size: 0.8rem; font-style: italic;">or drag and drop the file into the table</span>
                                </div>
                            </div>
                        </trustifi-table-c>
                    </div>
                    <br/>
                    <!--Attachments Blocklist-->
                    <div class="flex-column gap-3">
                        <div class="flex-column gap-2">
                            <div class="flex-row align-items-center gap-1">
                                <i class="far fa-times-circle text-danger" style="font-size: 0.7rem;"></i>
                                <b style="font-size: 0.845rem;">Attachments Blocklist</b>
                            </div>
                            <span class="text-muted lh-base" style="font-size: 0.9em;">Files from this list will always be considered malicious</span>
                        </div>
                        <trustifi-table-c
                                (ngInit)="blacklistFiles = null;"
								ngfDrop
                                multiple="1"
                                [(files)]="blacklistFiles"
                                (fileChange)="uploads(blacklistFiles, false)"
								[(validDrag)]="validDrag"
								[(invalidDrag)]="invalidDrag"
								[ngClass]="{'drag-and-drop-hover': validDrag, 'dragOverClassObj': validDrag}"

                                class="trustifi-table" style="z-index: 5; height: max(330px,25vw);"
                                [list]="currentLists?.attachments_blacklist"
                                [headers]="[
									{text: 'Blocklisted File', sortKey: 'name'},
									{text: 'Hash' },
									{text: 'Updated by' },
									{text: 'Created', sortKey: 'created', width: '135px'},
								]"
                                [cellsPrototype]="[
									{html: 'blacklistAttachmentNameCell', edit: {html:'blacklistAttachmentNameCellEdit'}},
									{textKey: 'hash', tooltip: true},
									{textKey: 'updated_by'},
									{textKey: 'created', textType: 'dateAndTime'},
								]"
                                [bulkActions] = "{
									enable: true,
									selectBulkActionCb:	selectMultipleAttachmentsBlacklistAction,
									initBulkActionsFunction: showAttachmentsBlacklistBulkActions,
									showInRed: {enable: true, terms: ['Remove']}
								}"
                                [cellActions] = "{
									enable: true,
									isSmaller: true,
									selectItemActionCb:	selectAttachmentsBlacklistAction,
									initActionsFunction: showAttachmentsBlacklistActions,
									showInRed: {enable: true, terms: ['Remove']}
								}"
                                (searchFunction)="searchAttachmentsBlacklist($event.searchTerm, $event.activeFilters)"
                                (confirmEditFunction)="confirmNewBlacklistAttachment($event.item, $event.isApproved)"
                                [options]="{
									importFromCsv : {cbFunction : uploadAttachmentsBlacklistFromFile, tooltip: 'A column named \'hash\' should contain the hashes'},
									exportToCsvFunction: exportAttachmentsBlacklistToCsv,
									itemsNameSingular: 'attachment',
									defaultSortKey: '-created',
								}"
                        >
							<ng-template #customCells let-item let-cellId="cellId">
								<!--action cells-->
								<div *ngIf="cellId === 'blacklistAttachmentNameCell'">
									<div class="flxRow hSpace05 ellipsis">
										<span style="display: block;" tooltip="{{item.name}}">{{item.name}}</span>
										<span class="ellipsis" style="min-width: 80px;" *ngIf="item.size">({{item.size | FormatBytes:0}})</span>
									</div>
								</div>
								<!--blacklist attachment - EDIT MODE-->
								<div class="flxRow hSpace05 h100" style="overflow: visible;" *ngIf="cellId === 'blacklistAttachmentNameCellEdit'">
									<input type="text"
										   [(ngModel)]="item.edit['name']"
										   placeholder="Attachment Name"
										   style="margin-bottom: 0; height: 100%; flex: 1 0;"
										   (keydown.enter) = "confirmNewBlacklistAttachment($event.item,$event.isApproved)">
									<input type="text"
										   [(ngModel)]="item.edit['hash']"
										   placeholder="SHA-256 or MD5"
										   style="margin-bottom: 0; margin-left: 5px; height: 100%; flex: 1 0;"
										   (keydown.enter) = "confirmNewBlacklistAttachment($event.item,$event.isApproved)">
								</div>
							</ng-template>

                            <!---->
                            <div tableButtons>
                                <div class="flxRow hSpace2 text-nowrap" style="align-items: baseline;">
									<div class="btn-with-dropdown" style="width: 250px;">
										<btn-c (action)="startAddRecord(currentLists?.attachments_blacklist);"
											   endIcon="far fa-plus"
											   [isDisabled]="currentLists?.attachments_blacklist?.isAddRecordActive">
											Add Blocklisted Attachment
										</btn-c>
										<app-dropdown-c [isLf]="true">
											<li	ngfSelect
												multiple="1"
												[(files)]="blacklistFiles"
												(fileChange)="uploads(blacklistFiles, false)">
												Add from my computer
											</li>
										</app-dropdown-c>
									</div>
                                    <span class="text-muted" style="font-size: 0.8rem; font-style: italic;">or drag and drop the file into the table</span>
                                </div>
                            </div>
                        </trustifi-table-c>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--Assign item to admin popup-->
    <popup-c class="overflownV" *ngIf="assignItemToAdminsInfo?.show"
           head="Assign Configuration"
           (closeCb)="assignItemToAdminsInfo.show = false;"
           (confirmCb)="addItemToAdminsExecute()"
           [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}" size="dynamic">
        <div class="flxClmn vSpace2" style="overflow: visible;">
            <span>Choose which plans the selected configuration should be assigned to</span>
            <div class="flxClmn vSpace1">
                <div class="flxRow hSpace2" style="align-items: center;">
                    <label class="radio-container" style="display: block; width: fit-content; margin: 0;">Choose specific plans:
                        <input type="radio" name="installPolicyAdmins" [value]="adminSelectionType?.specific"
                               [(ngModel)]="adminSelectionTypeSelection"
                               [checked]="adminSelectionTypeSelection === adminSelectionType?.specific">
                        <span class="checkmark"></span>
                    </label>
                    <app-dropdown-c style="width: 260px; height: 35px;"
                                  [items]="assignItemToAdminsInfo?.planAdmins"
                                  [isDisabled]="adminSelectionTypeSelection === adminSelectionType?.all"
                                  [isMultipleSelection]="true"
                                  itemDisplayKey="email" [enableSearch]="true"
                                  (onItemClicked)="chooseInstallPolicyAdmins()">
                    </app-dropdown-c>
                </div>

                <label class="radio-container" style="display: inline-block; height: 30px;">All plans
                    <input type="radio" name="installPolicyAdmins" [value]="adminSelectionType?.all"
                           [(ngModel)]="adminSelectionTypeSelection"
                           [checked]="adminSelectionTypeSelection === adminSelectionType?.all">
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </popup-c>

    <!--senders advanced popup-->
    <popup-c *ngIf="sendersAllowlistAdvancedInfoPopup?.show"
           head="Advanced Configuration"
		   subTitle="Manage configurations for sender {{sendersAllowlistAdvancedInfoPopup?.item?.email}}"
           (closeCb)="sendersAllowlistAdvancedInfoPopup.show = false;"
           size="dynamic">
        <div class="flxClmn vSpace1">

			<div class="flxClmn gap-1">
				<div class="flxRow gap-1">
					<h6>Override Advanced Settings</h6>
					<toggle-switch-c id="overrideAdvSettings"
								   [hideText]="true"
								   [(model)]="sendersAllowlistAdvancedInfoPopup.item.override_advanced_settings"
								   (onChange)="updateTpSendersWhiteListAdvanced('override_advanced_settings')">
					</toggle-switch-c>
				</div>
				<span>Bypass the customized advanced settings set on the senders allowlist</span>
			</div>

            <table class="simpleDataTable w100" style="table-layout: fixed;">
                <tr>
                    <td>
						Block Malicious Links
						<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Emails from this sender will be quarantine if malicious links are found"></i>
					</td>
                    <td>
                        <toggle-switch-c id="blockMaliciousLinksToggle"
                                       [hideText]="true"
									   [isDisabled]="!sendersAllowlistAdvancedInfoPopup.item.override_advanced_settings"
                                       [(model)]="sendersAllowlistAdvancedInfoPopup.item.whitelist_block_malicious_links"
                                       (onChange)="updateTpSendersWhiteListAdvanced('whitelist_block_malicious_links')">
                        </toggle-switch-c>
					</td>
                </tr>

                <tr>
                    <td>
						Block Malicious Files
						<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Emails from this sender will be quarantine if malicious files are found"></i>
					</td>
                    <td>
                        <toggle-switch-c id="blockMaliciousFiles"
                                       [hideText]="true"
									   [isDisabled]="!sendersAllowlistAdvancedInfoPopup.item.override_advanced_settings"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.whitelist_block_malicious_files"
                                       (onChange)="updateTpSendersWhiteListAdvanced('whitelist_block_malicious_files')">
                        </toggle-switch-c>
                    </td>
                </tr>

				<tr>
					<td>
						Allow All Sources
						<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="All sources will be accepted for emails from this sender"></i>
					</td>
					<td>
						<toggle-switch-c id="allowAllSources"
									   [hideText]="true"
									   [isDisabled]="!sendersAllowlistAdvancedInfoPopup.item.override_advanced_settings"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.allow_all_sources_whitelist"
									   (onChange)="updateTpSendersWhiteListAdvanced('allow_all_sources_whitelist')">
						</toggle-switch-c>
					</td>
				</tr>

                <tr>
                    <td>
						Notify Recipient Immediately For Quarantined Emails
						<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="If an email sent from this sender or domain is quarantined, then the recipient will receive an immediate notification"></i>
					</td>
                    <td>
                        <toggle-switch-c id="notifyRecipientToggle"
                                       [hideText]="true"
									   [isDisabled]="!sendersAllowlistAdvancedInfoPopup.item.override_advanced_settings"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.whitelist_notify_recipient_email_quarantined"
                                       (onChange)="updateTpSendersWhiteListAdvanced('whitelist_notify_recipient_email_quarantined')">
                        </toggle-switch-c>
                    </td>
                </tr>
            </table>
        </div>

		<hr/>
		<br/>
		<div class="flxClmn vSpace1">
			<div>
				<h6>Blocked File Types Exceptions</h6>
				<span>Choose to allow any of the file types below for this sender</span>
			</div>
			<table class="simpleDataTable w100" style="table-layout: fixed;">
				<tr>
					<td style="width: 250px;">Allow Macros</td>
					<td>
						<toggle-switch-c id="blockMacrosToggle"
									   [hideText]="true"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.file_types.allow_macros"
									   (onChange)="updateBlockFileTypeStatus('allow_macros')">
						</toggle-switch-c>
					</td>
				</tr>

				<tr>
					<td>Allow Scripts</td>
					<td>
						<toggle-switch-c id="blockScriptToggle"
									   [hideText]="true"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.file_types.allow_scripts"
									   (onChange)="updateBlockFileTypeStatus('allow_scripts')">
						</toggle-switch-c>
					</td>
				</tr>

				<tr>
					<td>Allow Executables</td>
					<td>
						<toggle-switch-c id="blockExecutablesToggle"
									   [hideText]="true"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.file_types.allow_executables"
									   (onChange)="updateBlockFileTypeStatus('allow_executables')">
						</toggle-switch-c>
					</td>
				</tr>

				<tr>
					<td>Allow Encrypted Attachments</td>
					<td>
						<toggle-switch-c id="blockEncryptedToggle"
									   [hideText]="true"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.file_types.allow_encrypted_attachments"
									   (onChange)="updateBlockFileTypeStatus('allow_encrypted_attachments')">
						</toggle-switch-c>
					</td>
				</tr>

				<tr>
					<td>Allow Encrypted Archives</td>
					<td>
						<toggle-switch-c id="blockArchivesToggle"
									   [hideText]="true"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.file_types.allow_encrypted_archives"
									   (onChange)="updateBlockFileTypeStatus('allow_encrypted_archives')">
						</toggle-switch-c>
					</td>
				</tr>

				<tr>
					<td>Allow Uncommon File Extensions</td>
					<td>
						<toggle-switch-c id="blockUncommonToggle"
									   [hideText]="true"
									   [(model)]="sendersAllowlistAdvancedInfoPopup.item.file_types.allow_uncommon"
									   (onChange)="updateBlockFileTypeStatus('allow_uncommon')">
						</toggle-switch-c>
					</td>
				</tr>
			</table>
		</div>
    </popup-c>

	<!--Sender allowlist sources popup-->
	<popup-c *ngIf="senderWhitelistSourcesPopup?.show"
			 head="Sender Sources for <b>{{senderWhitelistSourcesPopup?.item?.email}}</b>"
			 subTitle="List of sources stored for this allowlisted sender"
			 (closeCb)="senderWhitelistSourcesPopup.show = false"
			 [buttons]="{cancel: 'OK'}" size="medium" class="bs-enabled">
		<div class="flxClmn vSpace1 f-1-0" style="overflow: auto; max-height: 75vh;">
			<trustifi-table-c
				class="trustifi-table" style="flex: 1 0; z-index: 5;"
				[list]="senderWhitelistSourcesPopup.sources"
				[headers]="[
					{text: 'Received SPF'},
					{text: 'Sending MTA'}
				]"
				[cellsPrototype]="[
					{textKey: 'spf_domain', placeHolder: '-'},
					{textKey: 'mta_domain', placeHolder: '-'}
				]"
				[options]="{
					itemsNameSingular: 'source',
					defaultSortKey: '-last_seen'
				}"
				(searchFunction)="senderWhitelistSourcesPopup.search($event.searchTerm)"
			>
			</trustifi-table-c>
		</div>
	</popup-c>

	<!--Advanced Settings-->
	<popup-c class="bs-enabled" *ngIf="recipientConfigPopup?.show"
			 head="Personal List Settings" size="medium"
			 subTitle="Manage configurations for allow/block lists"
			 (closeCb)="recipientConfigPopup.show = false;"
			 [buttons]="{cancel: 'Done'}">
		<div class="flex-column f-1-0 gap-3" style="overflow: auto;">
			<div class="list-group list-group-flush settings-list-container">

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 1.5 0;">
						<b>Allow recipient personal allow/block lists</b>
						<span style="font-size: 0.9em;">Allows recipients to add senders, links, and attachments to their personal lists.</span>
					</div>
					<div class="content-container" style="flex: 1 0;">
						<toggle-switch-c id="whitelist_allow_recipient"
										 [hideText]="true"
										 [(model)]="config.threat_protection.whitelist_allow_recipient"
										 (onChange)="updateRecipientSettings('whitelist_allow_recipient')">
						</toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 1.5 0;">
						<b>Allow recipients to allowlist internal sender email addresses</b>
						<span style="font-size: 0.9em;">Allows recipients to add senders from their internal domains to their personal allowlist.<br/>
							Allowlisting internal domain senders may expose users to spoofing attacks.</span>
					</div>
					<div class="content-container" style="flex: 1 0;">
						<toggle-switch-c id="whitelist_senders_allow_recipient_plan_domains"
										 [hideText]="true"
										 [isDisabled]="!config.threat_protection.whitelist_allow_recipient"
										 [(model)]="config.threat_protection.whitelist_senders_allow_recipient_plan_domains"
										 (onChange)="updateRecipientSettings('whitelist_senders_allow_recipient_plan_domains')">
						</toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 1.5 0;">
						<b>Allow recipients to allowlist senders from malicious emails</b>
						<span style="font-size: 0.9em;">Allow recipients to add senders from malicious emails to their personal allowlist.</span>
					</div>
					<div class="content-container" style="flex: 1 0;">
						<toggle-switch-c id="whitelist_allow_recipient_for_malicious"
										 [hideText]="true"
										 [isDisabled]="!config.threat_protection.whitelist_allow_recipient"
										 [(model)]="config.threat_protection.whitelist_allow_recipient_for_malicious"
										 (onChange)="updateRecipientSettings('whitelist_allow_recipient_for_malicious')">
						</toggle-switch-c>
					</div>
				</div>
			</div>
		</div>
	</popup-c>

	<!--Senders Blocklist Advanced Settings-->
	<popup-c class="bs-enabled" *ngIf="blackListConfigPopup?.show"
			 head="Senders Blocklist Advanced Settings" size="dynamic"
			 subTitle="Manage configurations for blocklist senders below"
			 (closeCb)="blackListConfigPopup.show = false;"
			 (confirmCb)="blackListConfigPopup?.doneCb()"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Done', disabled: blackListConfigPopup.applyInProcess}}">
		<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
			<checkbox id="checkbox-blacklistSkipKeepRecord"
					  tooltipTxt="Emails received from blocklisted senders will not have a record in the Email Activity page"
					  [(model)]="blackListConfigPopup.skipKeepRecord">
				Do not keep email records
			</checkbox>
			<span *ngIf="blackListConfigPopup.skipKeepRecord" class="text-warning" style="font-size: 0.9em;">
				<i class="far fa-exclamation-triangle"></i>
				No records will be kept for emails received from all blocklisted senders. Settings for individual senders will be overridden.
			</span>
		</div>
	</popup-c>

	<!--Senders Allowlist Advanced Settings-->
	<popup-c class="bs-enabled" *ngIf="whiteListConfigPopup?.show"
			 head="Senders Allowlist Advanced Settings" size="dynamic"
			 subTitle="Manage configurations for allowlist senders below"
			 (closeCb)="whiteListConfigPopup.show = false;"
			 (confirmCb)="whiteListConfigPopup?.doneCb()"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Done', disabled: whiteListConfigPopup.applyInProcess}}">
		<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
			<checkbox id="checkbox-blockMaliciousLinks"
					  tooltipTxt="Emails from allowlist senders will be blocked if malicious links are found"
					  [(model)]="whiteListConfigPopup.blockMaliciousLinks">
				Block malicious links
			</checkbox>
			<checkbox id="checkbox-blockMaliciousFiles"
					  tooltipTxt="Emails from allowlist senders will be blocked if malicious files are found"
					  [(model)]="whiteListConfigPopup.blockMaliciousFiles">
				Block malicious files
			</checkbox>
			<checkbox id="checkbox-blockFilesUserPreferences"
					  tooltipTxt='Emails from allowlist senders will be blocked if they contain a file type which is set to be blocked (according to the "Block file types" settings)'
					  [(model)]="whiteListConfigPopup.blockFilesUserPreferences">
				Block files according to admin preferences
			</checkbox>
			<checkbox id="checkbox-allSourcesWhitelist"
					  tooltipTxt="All sources will be accepted for emails from allowlist senders"
					  [(model)]="whiteListConfigPopup.allSourcesWhitelist">
				Allow all sources
			</checkbox>
			<checkbox id="checkbox-recipientEmailQuarantined"
					  tooltipTxt="If an email send from a allowlist sender or domain is quarantined, the recipient will receive an immediate notification"
					  [(model)]="whiteListConfigPopup.recipientEmailQuarantined">
				Notify recipient immediately for quarantined emails
			</checkbox>
		</div>
	</popup-c>
</div>
